/* Página de produto: bolinhas de cor e cópia do código de desconto */
(function () {
  if (window.__lvFarben) return;
  window.__lvFarben = true;

  document.addEventListener('click', function (e) {
    var botao = e.target.closest ? e.target.closest('.lv-swatch') : null;
    if (!botao) return;

    var lista = botao.closest('.lv-swatches');
    var select = document.getElementById(lista.dataset.lvSelect);
    if (!select) return;

    select.value = botao.dataset.lvValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    lista.querySelectorAll('.lv-swatch').forEach(function (b) {
      var ativo = b === botao;
      b.classList.toggle('is-selected', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    });

    var rotulo = document.getElementById(lista.dataset.lvLabel);
    if (rotulo) rotulo.textContent = botao.dataset.lvValue;
  });
})();

/* Código de desconto: clicar copia para a área de transferência */
(function () {
  if (window.__lvGutschein) return;
  window.__lvGutschein = true;

  document.addEventListener('click', function (e) {
    var botao = e.target.closest ? e.target.closest('.lv-coupon__code') : null;
    if (!botao) return;

    var codigo = botao.dataset.lvCode || '';
    var dica = botao.querySelector('.lv-coupon__hint');
    var original = dica ? dica.textContent : '';

    function confirmar() {
      if (!dica) return;
      dica.textContent = botao.dataset.lvDone || 'OK';
      botao.classList.add('is-copied');
      setTimeout(function () {
        dica.textContent = original;
        botao.classList.remove('is-copied');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codigo).then(confirmar, function () {});
    } else {
      var campo = document.createElement('textarea');
      campo.value = codigo;
      campo.setAttribute('readonly', '');
      campo.style.position = 'absolute';
      campo.style.left = '-9999px';
      document.body.appendChild(campo);
      campo.select();
      try { document.execCommand('copy'); confirmar(); } catch (err) {}
      document.body.removeChild(campo);
    }
  });
})();

/* Data de entrega estimada: conta dias úteis a partir de hoje. */
(function () {
  var NAMEN = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function werktageAddieren(start, tage) {
    var d = new Date(start.getTime());
    var rest = tage;
    while (rest > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) rest--;
    }
    return d;
  }

  function zwei(n) { return (n < 10 ? '0' : '') + n; }

  function formatieren(d, modus) {
    var tag = zwei(d.getDate());
    var monat = zwei(d.getMonth() + 1);
    if (modus === 'lang') return NAMEN[d.getDay()] + ', ' + tag + '.' + monat + '.';
    return tag + '/' + monat;
  }

  function setzen(el) {
    var ziel = el.querySelector('[data-lv-datum]');
    if (!ziel) return;

    var min = parseInt(el.getAttribute('data-tage-min'), 10);
    var max = parseInt(el.getAttribute('data-tage-max'), 10);
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var modus = el.getAttribute('data-format') || 'kurz';

    if (isNaN(min) || min < 0) min = 5;
    if (isNaN(max) || max < min) max = min;

    var start = new Date();
    if (!isNaN(cutoff) && cutoff > 0 && start.getHours() >= cutoff) {
      start.setDate(start.getDate() + 1);
    }

    var von = werktageAddieren(start, min);
    var bis = werktageAddieren(start, max);

    ziel.textContent = min === max
      ? formatieren(von, modus)
      : formatieren(von, modus) + ' – ' + formatieren(bis, modus);
  }

  function starten() {
    var alle = document.querySelectorAll('[data-lv-lieferdatum]');
    for (var i = 0; i < alle.length; i++) setzen(alle[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
  document.addEventListener('shopify:section:load', starten);
})();
